import { render, staticRenderFns } from "./ArtistPage.vue?vue&type=template&id=f4da99ec&scoped=true"
import script from "./ArtistPage.vue?vue&type=script&lang=js"
export * from "./ArtistPage.vue?vue&type=script&lang=js"
import style0 from "./ArtistPage.vue?vue&type=style&index=0&id=f4da99ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4da99ec",
  null
  
)

export default component.exports